import { render, staticRenderFns } from "./UserRegisterForm.vue?vue&type=template&id=08517119&scoped=true&"
import script from "./UserRegisterForm.vue?vue&type=script&lang=js&"
export * from "./UserRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08517119",
  null
  
)

export default component.exports